module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAAJFBMVEVHcEx4eHh7e3t6enp3d3d6enp6enp5eXl7e3t5eXl5eXl6enr9YfcdAAAADHRSTlMAG5X1DeRrReBpi6sfZatTAAAAPUlEQVQoz2NgIA+wF6IJcDUJoApwNiuiCrCkGqEpcQseMCVT0ZVIWxTgV4FuBoYtdFDAhh6mGKGOES8UAgDP7xEh+P/uvwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/trends/dyn_message_ic_adv.png
// module id = ejRd
// module chunks = 1